<template>
  <section class="solution-section">
    <div class="section-container">
      <header class="section-heading">
        <h2>面向多种场景的档案解决方案</h2>
        <p>结合行业规范与实际业务需求，为组织构建安全、规范、可持续演进的档案体系。</p>
      </header>
      <div class="solution-grid">
        <button v-for="item in solutions" :key="item.id" class="solution-card" type="button" @click="openDigitalArchive(item.id)">
          <img :src="item.image" :alt="item.title" />
          <span class="solution-card-overlay"></span>
          <span class="solution-card-content">
            <strong>{{ item.title }}</strong>
            <small>{{ item.description }}</small>
            <span class="solution-card-more">了解详情 →</span>
          </span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeSolution',
  data () {
    return {
      solutions: [
        { id: 'dangan', title: '数字档案管理', description: '构建一体化数字档案体系', image: require('../../assets/images/solution/index1.webp') },
        { id: 'jituan', title: '集团企业档案管理', description: '统一管理多组织档案资产', image: require('../../assets/images/solution/index2.webp') },
        { id: 'gaoxiao', title: '高校档案管理', description: '助力高校档案智慧升级', image: require('../../assets/images/solution/index3.webp') },
        { id: 'danganguan', title: '档案馆三网建设', description: '打造安全可靠的档案馆网络', image: require('../../assets/images/solution/index4.webp') }
      ]
    }
  },
  methods: {
    openDigitalArchive (id) {
      this.$router.push({ path: '/digitalArchive', query: { id } })
    }
  }
}
</script>

<style scoped>
.solution-section { padding: 106px 0 112px; background: #fff; }
.section-container { width: min(1200px, calc(100% - 64px)); margin: 0 auto; }
.section-heading { max-width: 700px; margin: 0 auto 48px; text-align: center; }
.section-heading h2 { margin: 0; color: #20344e; font-size: clamp(30px, 3vw, 40px); font-weight: 600; }
.section-heading > p:last-child { margin: 17px 0 0; color: #728197; font-size: 16px; line-height: 1.8; }
.solution-grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 18px; }
.solution-card { position: relative; min-height: 336px; overflow: hidden; padding: 0; border: 0; background: #20344e; color: #fff; cursor: pointer; text-align: left; }
.solution-card > img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; transition: transform .35s ease; }
.solution-card-overlay { position: absolute; inset: 0; background: linear-gradient(180deg, rgba(18, 40, 67, .05) 25%, rgba(18, 40, 67, .9) 100%); }
.solution-card-content { position: absolute; right: 24px; bottom: 23px; left: 24px; display: block; }
.solution-card strong, .solution-card small, .solution-card-more { display: block; }
.solution-card strong { font-size: 21px; font-weight: 600; }
.solution-card small { margin-top: 9px; color: rgba(255,255,255,.82); font-size: 14px; }
.solution-card-more { margin-top: 20px; color: #bfd5ff; font-size: 13px; opacity: 0; transform: translateY(6px); transition: opacity .25s ease, transform .25s ease; }
.solution-card:hover > img, .solution-card:focus > img { transform: scale(1.06); }
.solution-card:hover .solution-card-more, .solution-card:focus .solution-card-more { opacity: 1; transform: translateY(0); }
.solution-card:focus-visible { outline: 3px solid #1f5dea; outline-offset: 3px; }
@media (max-width: 1024px) { .solution-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } .solution-card { min-height: 300px; } }
@media (max-width: 768px) { .solution-section { padding: 72px 0; } .section-container { width: calc(100% - 40px); } .section-heading { margin-bottom: 34px; } .section-heading > p:last-child { font-size: 14px; } .solution-card { min-height: 240px; } .solution-card-more { opacity: 1; transform: none; } }
@media (max-width: 480px) { .solution-grid { grid-template-columns: 1fr; } }
@media (prefers-reduced-motion: reduce) { .solution-card > img, .solution-card-more { transition: none; } }
</style>
